let mixins = {}
try {
  // noinspection NpmUsedModulesInstalled
  mixins = require('marketing/giftcards/_mixins/giftcard-list').default
} catch (e) {
  //
}

export default mixins
